import PeuTable from "../CostosFijos/PeuTable";
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionSerVivo = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionSerVivoTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionSerVivoTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionSerVivo;